import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import constants from 'Constants';
import ConfigStore from './Config/ConfigStore';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';


class RewardStore {

  @setter @observable id;
  @setter @observable name;
  @setter @toggle @observable active;
  @setter @toggle @observable displayInWidget;
  @setter @observable type;
  @setter @observable redemptionPoints;
  @setter @observable additionalNotes;
  @setter @observable config;

  static create(data={}) {
    const instance = new RewardStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "id": null,
      "name": "",
      "active": false,
      "displayInWidget": false,
      "type": "",
      "redemptionPoints": "",
      "additionalNotes": "",
      "config": new ConfigStore(),
    };
  }

  constructor(defaults=RewardStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=RewardStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "id"},
      {"field": "name"},
      {"field": "active"},
      {"field": "displayInWidget", "accessor": "display_in_widget"},
      {"field": "type"},
      {"field": "redemptionPoints", "accessor": "redemption_points"},
      {"field": "additionalNotes", "accessor": "additional_notes"},
      {"field": "config", "accessor": "config", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": ConfigStore},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @computed get typeOption() {
    return constants.REPERKS_REWARD_TYPE_OPTIONS.filter((option) => option.value === this.type)[0];
  }

  @computed get typeDisplay() {
    const option = this.typeOption;
    if (option) return option.label;
    return "";
  }

  @computed get iconClass() {
    const option = this.typeOption;
    if (option) return option.icon_class;
    return "";
  }
}

export default RewardStore;


